import React, { useEffect, useState } from "react";
import SmartFMnav from '../Assets/SmartFMnav.svg'
import '../css/saasproducts.css'
import '../css/signup.css'
import CommonGetMethod from '../Components/Helpercomponents/CommonGetMethod';
import Loading from "../Loading";
import CommonAPISelect from "../Components/Helpercomponents/CommonAPIMthod";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

function SaasProducts(props) {
    const [selectedProducts, setSelectedProducts] = useState([])
    const [products, setProducts] = useState([])
    const [step, setStep] = useState('select')      // 'select' | 'loading'
    const [animDone, setAnimDone] = useState(false)  // loading animation finished
    const [apiDone, setApiDone] = useState(false)    // API call succeeded
    const [error, setError] = useState('')

    useEffect(() => {
        const fetchData = async () => {
            const url = process.env.REACT_APP_NODE_SERVICE + '/saasproducts'
            const result = await CommonGetMethod(url)
            if (String(result?.Output?.status?.code) === '200' && result?.Output?.data?.length > 0) {
                setProducts(result.Output.data)
            }
        }
        fetchData()
    }, [])

    const toggleProduct = (id) => {
        setSelectedProducts((prev) =>
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        )
    }

    const handleProceed = async () => {
        if (selectedProducts.length === 0) {
            toast.warn('Please Select at least 1 product')
            return
        }
        setError('')
        setAnimDone(false)
        setApiDone(false)
        setStep('loading')

        const userID = props.state?.userID
        const url = `${process.env.REACT_APP_NODE_SERVICE}/FP8S19`
        const submitParam = {
            data: [{
                p1: 0, p2: userID, p3: true, p4: true, p5: null, p6: userID,
                p7: selectedProducts.join(','),
                p8: true, p9: null, p10: 0, p11: null, p12: 0, p13: null,
            }],
        }

        try {
            const res = await CommonAPISelect(url, submitParam)
            if (Number(res?.[0]?.status?.code) === 200) {
                setApiDone(true)
            } else {
                throw new Error('Request failed')
            }
        } catch (e) {
            setStep('select')
            setError('Something went wrong. Please try again.')
        }
    }

    const showModal = step === 'loading' && animDone && apiDone

    return (
        <div className="relative w-full min-h-screen overflow-auto">
            <ToastContainer position="top-center" autoClose={2000} hideProgressBar />
            {step === 'loading' && !showModal && (
                <Loading nextpage={() => setAnimDone(true)} />
            )}

            {step === 'select' && (
                <div>
                    <div className="NavBarContainer">
                        <div className="NavBarparentDiv">
                            <div className="NavBarparentSubDiv">
                                <a className="navBarimageContainer">
                                    <img src={SmartFMnav} className="NavbarLogoImage" alt="SmartFM_Image"
                                        title="SmartFM Logo" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="SelectProductListParent" id="productSection">
                        <div className="SelectProductSubContainer">
                            <div className="ProductTitleParent">
                                <h1 className="ProductTitleHead1">Proceed to select your desired products</h1>
                                <h6 className="ProductTitleHead2">Please select our product, that suitable for you business needs</h6>
                            </div>

                            <div id="productGrid" className="grid">
                                {products.map((product, index) => {
                                    const isSelected = selectedProducts.includes(product.id);

                                    return (
                                        <div
                                            key={product.id}
                                            className={`ProductsMainDiv ${isSelected ? "selected" : ""}`}
                                            style={{ animationDelay: `${index * 0.06}s` }}
                                            onClick={() => toggleProduct(product.id)}
                                        >
                                            <div className="ProductsParentDiv">
                                                <div className="ProductDetailsParent">
                                                    <img
                                                        src={product.image}
                                                        alt={product.alt}
                                                        title={product.alt}
                                                        className="ProductImageStyle"
                                                    />

                                                    <div className="ProductDetailsParent2">
                                                        <h3 className="ProductTitleText">{product.title}</h3>
                                                        <p className="ProductDesText">{product.description}</p>
                                                    </div>
                                                </div>

                                                <div
                                                    className="ProductCheckboxParent"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="CheckboxStyle"
                                                        checked={isSelected}
                                                        onChange={() => toggleProduct(product.id)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
                            <hr />

                            <div className="ProceedButtonSec">
                                <button className="ProductCancelBtn" onClick={() => props.clear?.(true)}>
                                    Cancel
                                </button>
                                <button
                                    className="ProProceedBtn"
                                    onClick={handleProceed}
                                    // disabled={selectedProducts.length === 0}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && (
                <RequestReceivedModal
                    email={props.state?.UserEmail}
                    onClose={() => {props.clear?.(true);window.location.href = localStorage.getItem('domain') }}
                />
            )}
        </div>
    )
}

export default SaasProducts


const RequestReceivedModal = ({ email = "m****ds.com", onClose }) => {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    width: "530px",
                    maxWidth: "90%",
                    backgroundColor: "#ffffff",
                    border: "1px solid #d9d9d9",
                    borderRadius: "12px",
                    padding: "40px 30px",
                    textAlign: "center",
                    fontFamily: "'Open Sans', Arial, sans-serif",
                    boxSizing: "border-box",
                }}
            >
                <h2
                    style={{
                        margin: "0 0 20px 0",
                        fontSize: "26px",
                        fontWeight: 600,
                        color: "#1f4370",
                    }}
                >
                    Thank You!
                </h2>

                <div
                    style={{
                        fontSize: "16px",
                        lineHeight: "26px",
                        color: "#666666",
                        marginBottom: "24px",
                    }}
                >
                    Your products request has been received by our sales team. You will
                    be notified with the product links through the given mail id
                    <div style={{ color: "#222222", fontWeight: 500 }}>{email}</div>
                </div>

                <div
                    style={{
                        fontSize: "16px",
                        lineHeight: "26px",
                        color: "#666666",
                        marginBottom: "30px",
                    }}
                >
                    You can explore our products without limit after 7 days.
                </div>

                <div>
                    <button
                        onClick={onClose}
                        style={{
                            width: "92px",
                            height: "32px",
                            backgroundColor: "#1f4370",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "4px",
                            fontSize: "15px",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    );
};